export type StarterOrPioneerVariant = 'starter' | 'growth'

export const useIsPioneerStarterOrGrowth = (): StarterOrPioneerVariant => {
  const location = window.location // eslint-disable-line no-restricted-properties
  const isGrowth = location.search.includes('campaigns=true')

  if (isGrowth) return 'growth'

  return 'starter'
}
